import { UserType } from "./user-info";

export interface Entity {
  extraInfo?: EntityExtraInfo;
}

export interface EntityExtraInfo {
  createdByType: UserType;
}

//#region Enum
export enum Operation {
  create = "create",
  read = "read",
  update = "update",
  delete = "delete",
}
//#endregion
